import React, { useMemo } from 'react';

import { FormikProps } from 'formik';

// components
import LoadingSpinner from '../../../components/nav/LoadingSpinner';

// hooks
import useFormulaTimingSlots from '../../../hooks/timing-slots/useTimingSlots';

import { CompoundTriggerType } from '../../../models/compound-trigger.model';
// models
import {
    FormulaDetailModel,
    FormulaViewSetupFormValue,
    ProcessedFormulaV1,
} from '../../../models/formula.model';
import { TimingSlotsModel } from '../../../models/timing-slots.model';

import FormulaDeliverySettings from './FormulaDeliverySettings';

interface FormulaDeliverySettingsWrapperProps {
    data?: FormulaDetailModel;
    isDisabled?: boolean;
    liveData?: ProcessedFormulaV1;
    formikProps?: FormikProps<FormulaViewSetupFormValue>;
}

const FormulaDeliverySettingsWrapper: React.FC<
    React.PropsWithChildren<FormulaDeliverySettingsWrapperProps>
> = ({ data, isDisabled, liveData, formikProps }) => {
    const { data: timingSlots, isPending: isLoading } = useFormulaTimingSlots();

    const isNotAampeOptimized = useMemo<boolean>(() => {
        const triggerType =
            data?.compound_trigger?.trigger_type ??
            CompoundTriggerType.AAMPE_OPTIMISED;
        return [
            CompoundTriggerType.SEND_IMMEDIATELY,
            CompoundTriggerType.SEND_WITH_DELAY,
        ].includes(triggerType);
    }, [data]);

    if (isLoading) {
        return <LoadingSpinner />;
    }
    return (
        <FormulaDeliverySettings
            data={data ?? liveData}
            isDisabled={isDisabled || isNotAampeOptimized}
            timingSlots={timingSlots as TimingSlotsModel[]}
            formikProps={formikProps}
        />
    );
};

export default FormulaDeliverySettingsWrapper;
